import React from "react";
import { Icon, Menu, Tab } from "semantic-ui-react";
import Products from "./Products";

import "./index.scss";

const CatalogWizard = ({ opportunity_id, account_id }) => (
    <Tab
        panes={[
            {
                menuItem: <Menu.Item><Icon className="fas fa-box" /> Products</Menu.Item>,
                render: () => (
                    <Products opportunity_id={opportunity_id} account_id={account_id} />
                )
            }
        ]}
        menu={{ color: 'blue', secondary: true, pointing: true }}
        defaultActiveIndex={0} />
)

export default CatalogWizard;
